import clsx from 'clsx'
import React from 'react'

import styles from './DescriptionList.module.css'
import { DescriptionListProps } from './DescriptionList.types'

const DescriptionList = ({
	children,
	className,
}: DescriptionListProps): JSX.Element => {
	return <dl className={clsx(styles.descriptionList, className)}>{children}</dl>
}

export default DescriptionList
